import { createEventCreator as event } from './ga';
import { SelfServiceAPI } from 'types';

type ListBooking = SelfServiceAPI.CancelledBooking | SelfServiceAPI.PastBooking | SelfServiceAPI.UpcomingBooking;

export const viewDetailsLink = event((booking: ListBooking) => ({
  category: 'View Details Link',
  action: getViewDetailsLinkAction(booking),
}));

export const loadMoreButton = event((offset: number, filter: string = '') => ({
  category: 'Load More Button',
  action: `Load More After First ${offset} Bookings${filter ? ` (${filter})` : ''}`,
}));

export const filterBookingList = event((filter: string = '') => ({
  category: 'Booking List Filter',
  action: `Filter Selected - ${filter} `,
}));

const getViewDetailsLinkAction = (booking: ListBooking) => {
  switch (true) {
    case booking.flags.isChangeInProgress:
      return 'Changes in Progress Booking Link Selected';
    case booking.flags.isCancelled:
      return 'Cancelled Booking Link Selected';
    default:
      return 'Confirmed Booking Link Selected';
  }
};
